import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonicBaseComponent } from '@front-end/core/ionic-hooks';
import { CostCenterSummary } from '@libs/core/api';
import { map } from 'rxjs';
import { ProjectsService } from '@front-end/core/services';
import { ModalController } from '@ionic/angular';
import { NgxAuthService } from 'ngx-auth-utils';
import { presentBillingInfoModal } from '../../billing/present-billing-info-modal';

@Component({
  selector: 'ui-current-cdc',
  templateUrl: './current-cdc.component.html',
  styleUrls: ['./current-cdc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentCdcComponent extends IonicBaseComponent {
  @Input() showRole = true;

  private _project?: CostCenterSummary | undefined;
  get project(): CostCenterSummary | undefined {
    return this._project;
  }

  @Input() set project(value: CostCenterSummary | undefined) {
    this._project = value;
  }

  private _showSuperOperatore?: boolean;
  get showSuperOperatore(): boolean | undefined {
    return this._showSuperOperatore;
  }

  @Input() set showSuperOperatore(value: boolean | undefined) {
    this._showSuperOperatore = value;
  }

  constructor(
    private readonly projectService: ProjectsService,
    private readonly modalController: ModalController,
    private readonly authService: NgxAuthService
  ) {
    super();
  }

  readonly superOperatore$ = this.projectService.selectedProject$.pipe(
    map((project) => project?.subtasks?.some((m) => m.superOperatore))
  );

  readonly isBuyer$ = this.projectService.isBuyerInSelectedProject();
  readonly isSuperBuyer$ = this.projectService.isSuperBuyerInSelectedProject();

  async openBillingInfo(): Promise<void> {
    const project = this.project;
    if (!project) {
      return;
    }

    await presentBillingInfoModal(
      this.modalController,
      this.authService,
      project
    );
  }
}
